import { studentRequests } from "api/studentApi";
import React from "react";
import { SelectInput, useGetList } from "react-admin";

const AcademicYearFilterInput = ({ onChange, label = "Академична година" }) => {
  const { data, isLoading } = useGetList(studentRequests.getAcademicYearsSelect(), {
    pagination: { page: 1, perPage: 100 },
    sort: { field: "name", order: "ASC" },
  });
  return (
    <SelectInput
      source="academicYearId"
      label={label}
      choices={data ?? []}
      isLoading={isLoading}
      fullWidth
      optionText="name"
      emptyText={"Всички"}
      defaultValue={data?.[0]?.id}
      onChange={onChange}
    />
  );
};

export default AcademicYearFilterInput;
